var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_3806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.833 4.66668H25.6663V7.00001H23.333V24.5C23.333 24.8094 23.2101 25.1062 22.9913 25.325C22.7725 25.5438 22.4758 25.6667 22.1663 25.6667H5.83301C5.52359 25.6667 5.22684 25.5438 5.00805 25.325C4.78926 25.1062 4.66634 24.8094 4.66634 24.5V7.00001H2.33301V4.66668H8.16634V2.33334H19.833V4.66668ZM10.4997 10.5V19.8333H12.833V10.5H10.4997ZM15.1663 10.5V19.8333H17.4997V10.5H15.1663Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_3806"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBin);
export default __webpack_public_path__ + "static/media/deleteBin.ee1a841a6ca3c9529913bbc13e353679.svg";
export { ForwardRef as ReactComponent };